import { connect } from 'react-redux';
import { change as changeFormValue } from 'redux-form';
import { getMealState } from '../utils/units';
import Meal from '../components/Meal';
import { getTravelerNames } from '../../common/utils/travelerNames';
import { MEAL } from '../../products';
const {
  name: PRODUCT_NAME
} = MEAL;
const updateLayoutType = (dispatch, {
  form
}) => layout => {
  dispatch(changeFormValue(form, `${PRODUCT_NAME}.layoutType`, layout));
};
const mapStateToProps = (state, {
  form,
  order
}) => {
  var _getMealState;
  const travelerNames = getTravelerNames(form, state, order === null || order === void 0 ? void 0 : order.travelers);
  return {
    mealState: (_getMealState = getMealState(form, state)) !== null && _getMealState !== void 0 ? _getMealState : [],
    travelerNames
  };
};
const mapDispatchToProps = (dispatch, form) => ({
  updateLayoutType: updateLayoutType(dispatch, form)
});
export default connect(mapStateToProps, mapDispatchToProps)(Meal);
//# sourceMappingURL=MealContainer.js.map